import * as React from "react";
const SvgFiBrandsAecom = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="m23.91 9.384.09 5.222h-1.281l.02-3.061-1.53 3.06h-.66l-.551-3.06-.89 3.06h-1.29l1.62-5.221h1.171l.61 2.94 1.51-2.94zM16.097 9.294c1.4.1 2.261 1.24 2.1 2.75-.16 1.572-1.42 2.732-2.85 2.632-1.401-.1-2.261-1.242-2.101-2.751.16-1.571 1.43-2.731 2.85-2.631m.86 2.88c.19-.88-.14-1.57-.81-1.71-.73-.15-1.401.41-1.601 1.34-.19.88.14 1.572.81 1.712.73.15 1.4-.41 1.6-1.341M13.505 9.713l-.25 1.25a1.71 1.71 0 0 0-1.15-.429c-.91 0-1.581.64-1.611 1.52-.02.842.521 1.402 1.35 1.402.261 0 .78-.03 1.131-.19l-.201 1.259c-.35.16-.9.19-1.16.19-1.471 0-2.461-1.07-2.411-2.601.06-1.58 1.3-2.831 2.801-2.831a2.7 2.7 0 0 1 1.501.43M9.534 9.384l-.18 1.211H5.682l.18-1.211zM8.934 13.386l-.18 1.22H5.082l.18-1.22zM8.793 11.394l-.19 1.21h-3.22l.18-1.21zM3.872 9.384l1.2 5.222h-1.24l-.21-1.02H1.741l-.43 1.02H0l2.46-5.222zm-.501 3.052-.38-1.811h-.01l-.76 1.81z"
    />
  </svg>
);
export default SvgFiBrandsAecom;
